<template>
    <div  :style="{'height':clientHeight-100+'px'}" v-loading="mainLoading">
        <div class="left">
            <div class="card card-body" style="max-height: 350px">
                <h3>
                    {{student.name}}【<span
                        v-for="headTeacher in student.headTeachers"> {{headTeacher.name}}</span>】
                </h3>
                <h4 v-if="student.student_star">
                    <el-rate
                            v-model="student.student_star.star_level"
                            :max="3"
                            disabled
                            text-color="#ff9900">
                    </el-rate>
                </h4>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form>
                            <el-form-item>

                            </el-form-item>
                            <el-form-item>
                                <h6 v-if="!student.current_education" class="card-subtitle">
                                    <span>教育经历未填写</span>
                                </h6>
                                <h6 v-else>
                                    {{student.current_education.grade.name||'无信息'}}
                                    -
                                    {{student.current_education.school.name||'无信息'}}</h6>
                                <div v-if="student.subjects" class="card-subtitle">
                                    学科：<span v-for="subject in student.subjects"
                                             :key="subject.id">{{subject.name}}&nbsp</span>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <div v-if="!student.hidePhone">
                                    <div>学生手机: {{student.phone}}</div>
                                    <div v-for="parent in student.parents">
                                        <div>
                                            {{parent.parent_identity}}：
                                            {{parent.name}}
                                        </div>
                                        <span>手机号:{{parent.phone}}</span>
                                    </div>
                                </div>
                                <div v-else>
                                    <div>学生手机: +86 *** **** ****</div>
                                    <div v-for="parent in student.parents">
                                        <div>
                                            {{parent.parent_identity}}：
                                            {{parent.name}}
                                        </div>
                                        <span>手机号:+86 *** **** ****</span>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="14">
                        <el-form ref="form" label-width="100px">
                            <el-form-item label="回访人">
                                <el-select v-model="returnVisitor.name"
                                           :disabled="true">
                                </el-select>
                            </el-form-item>
                            <el-form-item label="拨号人">
                                <el-select v-model="filter.headTeacher_id"
                                           remote
                                           :remote-method="handleSearchHeadTeacher"
                                           filterable placeholder="拨号人"
                                           :disabled=!disableYN>
                                    <el-option
                                            v-for="item in headTeachers"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="被回访人">
                                <el-select v-model="filter.parent_id"
                                           placeholder="被回访人"
                                           :disabled=!disableYN>
                                    <el-option
                                            v-for="item in beReturn"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="联系方式">
                                <el-select v-model="filter.contact_id"
                                           placeholder="联系方式"
                                           :disabled=!disableYN>
                                    <el-option
                                            v-for="item in contacts"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="startReturnTips" v-show=disableYN>开始回访
                                </el-button>
                                <el-button @click="cancelReturnTips" type="danger"
                                           v-show=!disableYN>取消回访
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <div class="m-portlet" :style="{'height':clientHeight-470+'px','margin-top':10+'px'}">
                <vue-scroll :ops="$ops">
                    <div class="card-body">
                        <el-form label-position="top">
                            <div v-for="(item,index) in problems" :key="index">
                                <div style="font-size: 20px">
                                    {{item.title}}
                                </div>
                                <el-form-item v-for="(item1,index1) in item.content" :label="item1.problem" :key="index1">
                                    <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 2, maxRows: 20}"
                                            placeholder=""
                                            v-model="item1.content"
                                            :disabled="disableYN"
                                    >
                                    </el-input>
                                </el-form-item>
                            </div>

                        </el-form>
                        <el-col :span="12">
                            <div>
                                <el-row>
                                    <el-col :span="12">
                                        <el-button @click="endReturnTips" type="success" v-show=!disableYN>结束回访
                                        </el-button>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                    </div>
                </vue-scroll>
            </div>
        </div>
        <div class="right">

            <div :style="{'height': 340-heightChange+'px'}" @click="changeHeight(0)">
                <student-period></student-period>
            </div>

            <div :style="{'height': clientHeight-440+heightChange+'px'}" @click="changeHeight(150)">
                <el-tabs v-model="activeName" type="border-card">
                    <el-tab-pane label="学生详情" name="studentDetail">
                        <vue-scroll :ops="$ops">
                            <div :style="{'height':(clientHeight)*3/7+'px'}">
                                <div class="card-body">
                                    <student-score></student-score>
                                </div>
                            </div>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="课堂反馈" name="classFeedback">
                        <vue-scroll :ops="$ops">
                            <div :style="{'height':(clientHeight)*3/7+'px'}">
                                <CourseFeedback></CourseFeedback>
                            </div>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="更换班级" name="changeClass">
                        <vue-scroll :ops="$ops">
                            <div :style="{'height':(clientHeight)*3/7+'px'}">
                                <StudentCourseRecording></StudentCourseRecording>
                            </div>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="往期回访记录" name="returnVisitRecord">
                        <vue-scroll :ops="$ops">
                            <div :style="{'height':(clientHeight)*3/7+'px'}">
                                <PastReturnVisit></PastReturnVisit>
                            </div>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="余课情况" name="reaminClassSituation">
                        <vue-scroll :ops="$ops">
                            <div :style="{'height':(clientHeight)*3/7+'px'}">
                                <InsufficientCourses></InsufficientCourses>
                            </div>
                        </vue-scroll>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .withRightBar {
        margin-right: 400px;
    }

    .rightBar {
        box-shadow: -30px 0px 30px -30px rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 0;
        right: 0;
        width: 400px;
        height: 100%;
    }

    .redCircle {
        background: #f56c6c;
        color: #fff;
        padding: 2px;
        border-radius: 5px;
    }

    .left {
        float: left;
        width: 550px;
    }

    .right {
        margin-left: 555px;
    }
</style>
<script>
    import StudentPeriod from '@/views/Student/Show/StudentPeriod/StudentPeriod.vue'
    import StudentScore from '@/views/Student/Show/Score/StudentScore.vue';
    import StudentCourseRecording from '@/views/Student/Show/CourseRecording/StudentCourseRecord.vue';
    import CourseFeedback from './components/CourseFeedback.vue';
    import PastReturnVisit from './components/PastReturnVisit.vue';
    import InsufficientCourses from './components/InsufficientCourses.vue';

    export default {
        name: "ReturnVisitDetail",
        data() {
            return {
                path: '/returnVisit/detail',
                activeName: 'studentDetail',
                cannotUse: false,
                mainLoading: true,
                disableYN: true,
                temp: true,
                loading: 'true',
                heightChange:0,
                filter: {
                    parent_id: '',
                    headTeacher_id: '',
                    contact_id:''
                },
                student_id: '',
                return_id: '',
                returnVisitor: {
                    name: ''
                },
                problems:[
                    {
                        id:1,
                        title:'一、询问对墨帝是否满意',
                        content: [
                            {
                                id:1,
                                problem:'1.同学你好，我想问一下你最近学校里面学的怎么样呀？',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'2.墨帝的课程一个月学下来难度觉得怎么样？进度还合适吗？老师上课的风格还适应吗？',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'3.那你觉得最近墨帝上课的内容对你有帮助哇？',
                                answer:'',
                            },
                            {
                                id:4,
                                problem:'4.那你考虑在墨帝的各科换一个老师试一下哇？',
                                answer:'',
                            },
                            {
                                id:5,
                                problem:'5.那这个老师带你带到毕业你觉得咋样？',
                                answer:'',
                            },

                        ],
                    },
                    {
                        id:2,
                        title:'二、不满意且说得出哪里不好',
                        content: [
                            {
                                id:1,
                                problem:'1.那你觉得这个任课老师具体是哪里讲的不好呢？',
                                answer:'',
                            },
                        ],
                    },
                    {
                        id:3,
                        title:'三、知识点询问，确保上课有没有问题',
                        content: [
                            {
                                id:1,
                                problem:'1.老师上课讲的xxx知识点你懂了哇？',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'2.老师上课讲的这些知识点是你们现在正在学的东西哇？',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'3.老师上课讲的例题在作业中会出现类似的题型哇？',
                                answer:'',
                            },
                            {
                                id:4,
                                problem:'4.老师上课讲的例题在考试中会出现类似的题型哇？',
                                answer:'',
                            },
                        ],
                    },
                    {
                        id:4,
                        title:'四、上课没有问题，确保课后吸收情况',
                        content: [
                            {
                                id:1,
                                problem:'1.学校作业的正确率咋样？',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'2.那如果作业/考试中出现过类似的题目，你能做的对哇？',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'3.老师上课讲过的东西，你课后会看哇？每周看几次，每次看多久？',
                                answer:'',
                            },
                        ],
                    },
                ],

                contacts:[
                    {
                        id:1,
                        name:'家长电话'
                    },
                    {
                        id:2,
                        name:'家长微信'
                    },
                    {
                        id:3,
                        name:'学生电话'
                    },
                    {
                        id:4,
                        name:'学生微信'
                    },
                ],
                student: {
                    avatar_url: '',
                    name: '',
                    star: '',
                    student_star: {},
                    headTeacher: {
                        id: '',
                        name: '',
                    },
                    current_education: '',
                    studentSubjects: '',
                    phone: ''
                },
                headTeachers: [],
                beReturn: [],


                attribute: [],
                form: {
                    returnOpinion:'',
                    attribute_id:'',
                    remark:'',
                    attributeOpinion:'',
                    sellClassFeedback:'',
                },

                //在读课程概况
                studentPeriod: {
                    showPopover:false,
                    studentCartPeriods: [],
                    studentActivePeriods: [],
                    loading: true,
                    activePeriod: {
                        button_loading: false,
                        loading: true,
                        reason: '',
                        status: 'active',
                    },
                    //StudentPeriod-AbsentPeriod
                    absentPeriod: {
                        button_loading: false,
                        loading: true,
                        reason: '',
                        status: 'absent',
                    },
                    //StudentPeriod-FinishPeriod
                    finishPeriod: {
                        finishPeriod: [
                            {
                                id: '',
                                content: '',
                                serious_degree: null,
                                note_degree: null,
                                review_degree: null,
                                returnVisit: '1',
                                status: 'finished',
                            }
                        ],
                        openFinishedPeriod: {
                            id: '',
                            content: '',
                            serious_degree: null,
                            note_degree: null,
                            review_degree: null,
                            returnVisit: '1',
                            status: 'finished',
                        },
                        loading: true,
                        classPlanStudent_id: '',
                        button_loading: false,
                    },
                    leavingPeriod: {
                        button_loading: false,
                        title: '缺勤/请假',
                        loading: 'true',
                        reason: '',
                        left: 'left',
                    },
                    switchingPeriod: {
                        loading: true,
                        message: '',
                    },
                    applyReasons:{
                        button_loading: false,
                        title: '缺勤/请假',
                        loading: 'true',
                        applyDetails: '',
                        left: 'left',
                    },
                },
                //学生成绩
                schoolScore: {
                    loading: true,
                    subjectCheck: false,
                    resultView: '',
                    page: '',
                    activeTab: '1',
                    organizationServiceScores: [],
                    schoolScores: {
                        schoolExam: {
                            name: '',
                            date: '',
                            schoolClass: '',
                            mainScore: '',
                            sumScore: '',
                            sumClassRank: '',
                            sumGradeRank: '',
                            sumAreaRank: '',
                            mainClassRank: '',
                            hasLook: '',
                            studentSchoolScores: {
                                score: '',
                                classRank: '',
                                gradeRank: '',
                                areaRank: '',
                                examSubject: {
                                    subject: {
                                        name: '',
                                    },
                                    totalScore: '',
                                    gradeAvgScore: '',
                                    areaAvgScore: '',
                                },
                                school_exam_school_class: {
                                    mainClassAvgScore: '',
                                    sumClassAvgScore: '',
                                    classAvgScore: '',
                                },
                            },
                            schoolExam: {
                                mainGradeAvgScore: '',
                                mainAreaAvgScore: '',
                                sumGradeAvgScore: '',
                                sumAreaAvgScore: '',
                            },
                            school_exam_school_class: {
                                mainClassAvgScore: '',
                                sumClassAvgScore: '',
                                classAvgScore: '',
                            },
                            grade: {
                                name: '',
                            },
                        }
                    },
                    dialog_UpdateMainSchoolScore: {
                        button_loading: false,
                        student_schoolExam: {
                            name: '',
                            date: '',
                            school: {
                                name: ''
                            },
                            grade: {
                                name: ''
                            },
                            school_exams: {
                                name: '',
                                date: '',
                            },
                            schoolExam_schoolClass_id: '',
                            mainScore: '',
                            sumScore: '',
                            mainClassRank: '',
                            mainGradeRank: '',
                            mainAreaRank: '',
                            sumClassRank: '',
                            sumGradeRank: '',
                            sumAreaRank: '',
                            schoolScores: {
                                school_exam_subject: {
                                    subject: {
                                        name: ''
                                    },
                                },
                                score: '',
                                classRank: '',
                                gradeRank: '',
                                areaRank: '',
                            },
                        },
                        schoolClasses: {
                            id: '',
                            name: '',
                        },
                    },
                    dialog_AddSchoolScore: {
                        title: '添加学校成绩',
                        button_loading: false,
                        loading: true,
                        subjectCheck: false,
                        school_val: {
                            schoolExams: [],
                            examSubjects: []
                        },
                        outlineForm: {
                            schoolClass_id: '',
                            grade_id: '',
                            school_id: '',
                            school_name: '',
                            schoolExam_id: '',
                            schoolExam_name: '',
                            examDate: '',
                            mainClassRank: '',
                            sumClassRank: '',
                            mainGradeRank: '',
                            mainAreaRank: '',
                            sumGradeRank: '',
                            sumAreaRank: '',
                        },
                        grades: '',
                        subjects: '',
                        exam_status: true,
                        // schoolScores: [],
                        schoolClasses: [],
                    },
                },

                courseFeedback: {
                    teacherFeedback: {
                        total: 0,
                        currentPage: 1,
                        currentPageSize: 10,
                        teacherFeedback: {},
                        loading: true,
                    },
                    teacherReturnVisit: {
                        total: 0,
                        currentPage: 1,
                        currentPageSize: 10,
                        teacherReturnVisits: {},
                        loading: true,
                    },
                    activeTab: 'teacherEvaluation',

                },

                pastReturnVisit: {
                    loading: true,
                    visualDetail: false,
                    returnVisit: '',
                    headTeachers: '',
                    detailData: [],
                    total: 0,
                    currentPage: 1,
                    currentPageSize: 10,
                    student: [],
                    form: {
                        parentsName: '',
                        returnVisitor: '',
                        complaintsDate: '',

                    }
                },

                insufficientCourse: {
                    status: '',
                    loading: true,
                    teacherName: '',
                    total: 0,
                    currentPage: 1,
                    currentPageSize: 10,
                    insufficientCourses: [],
                    subjects: [],
                    subject_id: [],
                    classDetail: [],
                    section_name: [],
                },

                studentCourseRecord: {
                    disableYN: true,
                    courseRecord: 1,
                    activeTab: '1',
                    loading: true,
                    studentActivePeriods: [{
                        class_id: '',
                        class_name: '',
                        classroom_name: '',
                        course_name: '',
                        grade_name: '',
                        id: '',
                        original_unit_period_price: '',
                        period: '',
                        retire_period: '',
                        section_name: '',
                        semester_id: '',
                        semester_name: '',
                        studentEvaluation: {
                            score: '',
                        },
                        studentUsePeriod: {
                            absent_count: '',
                            active_count: '',
                        },
                        subject_name: '',
                        teacher_name: '',
                        template_time: '',
                        unit_period_price: '',
                    }],
                    studentFinishedPeriods: {
                        class_id: '',
                        class_name: '',
                        classroom_name: '',
                        course_name: '',
                        grade_name: '',
                        id: '',
                        original_unit_period_price: '',
                        period: '',
                        retire_period: '',
                        section_name: '',
                        semester_id: '',
                        semester_name: '',
                        studentEvaluation: {
                            score: '',
                        },
                        studentUsePeriod: {
                            absent_count: '',
                            active_count: '',
                        },
                        subject_name: '',
                        teacher_name: '',
                        template_time: '',
                        unit_period_price: '',
                    },
                    studentCancelPeriods: {
                        class_id: '',
                        class_name: '',
                        classroom_name: '',
                        course_name: '',
                        grade_name: '',
                        id: '',
                        original_unit_period_price: '',
                        period: '',
                        retire_period: '',
                        section_name: '',
                        semester_id: '',
                        semester_name: '',
                        studentEvaluation: {
                            score: '',
                        },
                        studentUsePeriod: {
                            absent_count: '',
                            active_count: '',
                        },
                        subject_name: '',
                        teacher_name: '',
                        template_time: '',
                        unit_period_price: '',
                    },
                    studentInvoice: {
                        loading: false,
                        invoiceDetail: false,
                        showOn: false,
                        invoiceDetail_val: {},
                        paymentType: {
                            money: '',
                            zfb: '',
                            wx: '',
                            bank: '',
                            discount: '',
                            balance: ''
                        },
                        studentInvoices: [],
                        invoices: {},
                        page: ''
                    },
                    studentHistoryPeriod: {
                        studentActivePeriods: {},
                        studentPeriodStyles: [
                            {
                                name: '未上',
                                color: 'rgba(216,216,216)'
                            },
                            {
                                name: '签到',
                                color: '#D2EAB9'
                            },
                            {
                                name: '缺席',
                                color: '#946767'
                            },
                            {
                                name: '调课',
                                color: '#81AEE4'
                            },
                            {
                                name: '旷课',
                                color: '#E77E7E'
                            },
                            {
                                name: '请假',
                                color: 'rgba(133,214,225,1)'
                            },
                            {
                                name: '退费',
                                color: '#F5A77C'
                            },
                            {
                                name: '待购',
                                color: 'rgba(204,204,0,1)'
                            },
                            {
                                name: '未买',
                                color: '#898989'
                            },
                            {
                                name: '分期',
                                color: 'rgb(213,42,136)'
                            }
                        ],
                        rectH: 70 * 2,
                        row: '1',
                        loading: true,
                        // studentActivePeriods: [],
                        // studentCartPeriods: [],
                    },
                    dialog_CancelCourse: {
                        title: '取消课程',
                        button_loading: false,
                        loading: true,
                        studentPeriod: {
                            id: '',
                            unit_period_price: '',
                        },
                        retire_period: '',
                        reason: '',
                        reason_id: '',
                    },
                    dialog_ChangeCourse: {
                        title: '更换课程',
                        loading: true,
                        studentPeriod: {
                            id: '',
                            unit_period_price: '',
                        },
                        button_loading: false,
                        retire_period: '',
                        reason: '',
                        reason_id: '',
                    },
                },
                dialog_InvoiceDetail: {
                    loading: true,
                    invoiceDetail_val: {
                        invoiceItems: [
                            {
                                semester: {
                                    name: ''
                                },
                                classx: {
                                    name: '',
                                    class_type_name: '',
                                },
                                section: {
                                    name: ''
                                },
                                teacher_name: '',
                                start_time: '',
                                period: '',
                                original_unit_period_price: '',
                                discount: '',
                                sum_price: '',
                                versionNumber: '',
                                proportion: '',
                            }
                        ],
                        studentPayment: [{
                            id: '',
                            invoice_id: '',
                            balance: '',
                            payment_type: {
                                id: '',
                                name: '',
                            },
                            payment_type_id: '',
                            remark: '',
                            student_id: '',
                        }],
                        student_name: '',
                        student_school: '',
                        student_grade: '',
                        parent_name: '',
                        student_phone: '',
                        parent_phone: '',
                        hasPay: '',
                        type: '',
                        id: '',
                        version: '',
                    },
                    hasMoney: 0,
                    zfb: 0,
                    wetChat: 0,
                    bank: 0,
                    cash: 0,
                    discount: 0,
                    headTeacherLimit: 0,
                    periodUse: 0,
                    periodLklBank: 0,
                    periodLklWetChat: 0,
                    periodLklZfb: 0,
                    coupon: 0,
                    showOn: false,
                    printOn: true,
                    maxHeight: 800,
                },
                dialog_InvoiceBill: {
                    loading: false,
                    invoiceBills: [],
                    invoiceBillsLength: 0,
                },
            };
        },
        components: {
            'student-period': StudentPeriod,
            'student-score': StudentScore,
            PastReturnVisit,
            CourseFeedback,
            InsufficientCourses,
            StudentCourseRecording
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            right_level() {
                return this.$store.state.user.employee.right_level;
            }
        },
        mounted() {
        },
        created() {
            this.student_id = this.$route.params.id;
            this.mainLoading = false;
            this.handleCreate();
            this.handleInit();
            this.handleIndexDetail();
        },
        methods: {
            changeHeight(height){
                if(this.clientHeight<=768){
                    this.heightChange=height;
                }else{
                    this.heightChange=0;
                }
            },
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {'student_id': this.student_id})
            },
            handleIndexDetail() {
                this.$wApi.send(this.path, 'detail', {'student_id': this.student_id})
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.headTeachers = data.headTeachers;
                        this.beReturn = data.beReturn;
                        this.returnVisitor = data.returnVisiter;
                        this.filter.headTeacher_id = data.headTeacher_id;
                        this.attribute = data.attribute;
                        break;
                    case 'detail':
                        this.student = data.student;
                        break;
                    case 'search_headTeacher':
                        this.headTeachers = data.headTeacherName;
                        break;
                    case 'start_return':
                        this.return_id = data.return_id;
                        this.disableYN = false;
                        this.$message({
                            message: '开始回访',
                            type: 'success'
                        });
                        break;
                    case 'cancel_return':
                        this.filter.headTeacher_id = '';
                        this.filter.parent_id = '';
                        this.filter.contact_id = '';
                        this.disableYN = true;
                        this.$message({
                            type: 'success',
                            message: '回访已取消 !'
                        });
                        break;
                    case 'end_return':
                        this.disableYN = true;
                        this.filter.headTeacher_id = '';
                        this.filter.parent_id = '';
                        this.filter.contact_id = '';
                        this.form.attribute_id = '';
                        this.form.attributeOpinion = '';
                        this.form.returnOpinion = '';
                        this.form.sellClassFeedback = '';
                        this.form.remark = '';
                        this.problems=[
                        {
                            id:1,
                            title:'一、询问对墨帝是否满意',
                            content: [
                                {
                                    id:1,
                                    problem:'1.同学你好，我想问一下你最近学校里面学的怎么样呀？',
                                    answer:'',
                                },
                                {
                                    id:2,
                                    problem:'2.墨帝的课程一个月学下来难度觉得怎么样？进度还合适吗？老师上课的风格还适应吗？',
                                    answer:'',
                                },
                                {
                                    id:3,
                                    problem:'3.那你觉得最近墨帝上课的内容对你有帮助哇？',
                                    answer:'',
                                },
                                {
                                    id:4,
                                    problem:'4.那你考虑在墨帝的各科换一个老师试一下哇？',
                                    answer:'',
                                },
                                {
                                    id:5,
                                    problem:'5.那这个老师带你带到毕业你觉得咋样？',
                                    answer:'',
                                },

                            ],
                        },
                        {
                            id:2,
                            title:'二、不满意且说得出哪里不好',
                            content: [
                                {
                                    id:1,
                                    problem:'1.那你觉得这个任课老师具体是哪里讲的不好呢？',
                                    answer:'',
                                },
                            ],
                        },
                        {
                            id:3,
                            title:'三、知识点询问，确保上课有没有问题',
                            content: [
                                {
                                    id:1,
                                    problem:'1.老师上课讲的xxx知识点你懂了哇？',
                                    answer:'',
                                },
                                {
                                    id:2,
                                    problem:'2.老师上课讲的这些知识点是你们现在正在学的东西哇？',
                                    answer:'',
                                },
                                {
                                    id:3,
                                    problem:'3.老师上课讲的例题在作业中会出现类似的题型哇？',
                                    answer:'',
                                },
                                {
                                    id:4,
                                    problem:'4.老师上课讲的例题在考试中会出现类似的题型哇？',
                                    answer:'',
                                },
                            ],
                        },
                        {
                            id:4,
                            title:'四、上课没有问题，确保课后吸收情况',
                            content: [
                                {
                                    id:1,
                                    problem:'1.学校作业的正确率咋样？',
                                    answer:'',
                                },
                                {
                                    id:2,
                                    problem:'2.那如果作业/考试中出现过类似的题目，你能做的对哇？',
                                    answer:'',
                                },
                                {
                                    id:3,
                                    problem:'3.老师上课讲过的东西，你课后会看哇？每周看几次，每次看多久？',
                                    answer:'',
                                },
                            ],
                        },
                    ];
                        this.$set(this.pastReturnVisit.returnVisit, data.returnVisit.id, data.returnVisit);
                        this.$message({
                            type: 'success',
                            message: '回访已结束 !'
                        });
                        break;
                    case 'studentPeriod':
                        this.studentPeriod.studentActivePeriods = data.studentPeriod.studentPeriod;
                        this.studentPeriod.loading = false;
                        break;
                    case 'get_applyReason':
                        this.studentPeriod.applyReasons.applyDetails = data.studentApplys;
                        break;
                    case 'schoolScore':
                        if (Object.keys(data.schoolScore.student_schoolExams).length != 0) {
                            this.schoolScore.schoolScores = data.schoolScore.student_schoolExams
                        } else {
                            this.schoolScore.schoolScores = new Object();
                        }
                        // if (Object.keys(data.schoolScore.organizationServiceScores).length != 0) {
                        //     this.schoolScore.organizationServiceScores = data.schoolScore.organizationServiceScores
                        // } else {
                        //     this.schoolScore.organizationServiceScores = new Object();
                        // }
                        this.schoolScore.loading = false;

                        break;
                    case 'teacher_feedBack':
                        if (Object.keys(data.teacherFeedback).length > 0) {
                            this.courseFeedback.teacherFeedback.teacherFeedback = data.teacherFeedback
                        } else {
                            this.courseFeedback.teacherFeedback.teacherFeedback = new Object();
                        }
                        this.courseFeedback.teacherFeedback.total = data.total;
                        this.courseFeedback.teacherFeedback.loading = false;
                        break;
                    case 'teacher_returnVisit':
                        this.courseFeedback.teacherReturnVisit.teacherReturnVisits = data.teacherReturnVisits;
                        this.courseFeedback.teacherReturnVisit.total = data.total;
                        this.courseFeedback.teacherReturnVisit.loading = false
                        break;
                    case 'past_returnVisit':
                        if (Object.keys(data.returnVisit).length > 0) {
                            this.pastReturnVisit.returnVisit = data.returnVisit
                        } else {
                            this.pastReturnVisit.returnVisit = new Object();
                        }
                        this.pastReturnVisit.total = data.total
                        this.pastReturnVisit.loading = false;
                        break;
                    case 'check_return':
                        this.pastReturnVisit.detailData = data.detailData;
                        this.pastReturnVisit.visualDetail = true;
                        break;
                    case 'insufficient_courses':
                        if (Object.keys(data.classes).length > 0) {
                            this.insufficientCourse.insufficientCourses = data.classes
                        } else {
                            this.insufficientCourse.insufficientCourses = new Object();
                        }
                        this.insufficientCourse.subjects = data.subjects
                        this.insufficientCourse.total = data.total
                        this.insufficientCourse.loading = false
                        break;
                    case 'studentCourseRecord':
                        if (Object.keys(data.studentCourseRecord.studentPeriod_active).length != 0) {
                            this.studentCourseRecord.studentActivePeriods = data.studentCourseRecord.studentPeriod_active
                        } else {
                            this.studentCourseRecord.studentActivePeriods = new Object();
                        }
                        if (Object.keys(data.studentCourseRecord.studentPeriod_finished).length != 0) {
                            this.studentCourseRecord.studentFinishedPeriods = data.studentCourseRecord.studentPeriod_finished
                        } else {
                            this.studentCourseRecord.studentFinishedPeriods = new Object();
                        }
                        if (Object.keys(data.studentCourseRecord.studentPeriod_cancel).length != 0) {
                            this.studentCourseRecord.studentCancelPeriods = data.studentCourseRecord.studentPeriod_cancel
                        } else {
                            this.studentCourseRecord.studentCancelPeriods = new Object();
                        }
                        this.studentCourseRecord.loading = false;
                        break;
                    case 'showStudentInvoice':
                        if (Object.keys(data.showStudentInvoice.studentInvoices).length != 0) {
                            this.studentCourseRecord.studentInvoice.studentInvoices = data.showStudentInvoice.studentInvoices;
                        } else {
                            this.studentCourseRecord.studentInvoice.studentInvoices = new Object();
                        }
                        break;
                    case 'invoiceDetail':
                        this.dialog_InvoiceDetail.showOn = true;
                        this.dialog_InvoiceDetail.invoiceDetail_val = data.studentInvoice;
                        this.dialog_InvoiceDetail.loading = false;
                        break;
                    case 'invoiceBill':
                        this.dialog_InvoiceBill.invoiceBills = data.invoiceBills;
                        this.dialog_InvoiceBill.invoiceBillsLength = data.invoiceBills.length;
                        this.dialog_InvoiceBill.loading = false;
                        break;
                    case 'activeAndAbsentClass':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.studentPeriod.absentPeriod.button_loading = false;
                        this.studentPeriod.activePeriod.button_loading = false;
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        break;
                    case 'activeAndAbsentClassError':
                        this.studentPeriod.activePeriod.button_loading = false;
                        this.studentPeriod.absentPeriod.button_loading = false;
                        break;
                    case 'leavingPeriod':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.studentPeriod.leavingPeriod.button_loading = false;
                        this.studentPeriod.studentActivePeriods = data.studentPeriod.studentPeriod;
                        if (data.student_cashCoupon) {
                            this.$set(this.studentWallet.cashCoupons, data.student_cashCoupon.id, data.student_cashCoupon)
                        }

                        if (data.studentBalance) {
                            this.$set(this.studentWallet.studentBalances, data.studentBalance.id, data.studentBalance)
                        }

                        if (data.studentLesson) {
                            this.$set(this.studentWallet.studentLessons, data.studentLesson.id, data.studentLesson)
                        }

                        if (data.studentCoupon) {
                            this.$set(this.studentWallet.studentCoupons, data.studentCoupon.id, data.studentCoupon)
                        }

                        this.studentWallet.sum_cashCoupon = data.sum_cashCoupon;
                        this.studentWallet.hasMoney = data.hasMoney;
                        this.studentWallet.disputeMoney = data.disputeMoney;
                        this.studentWallet.couponMoney = data.couponMoney;
                        break;
                    case 'leavingPeriodError':
                        this.studentPeriod.leavingPeriod.button_loading = false;
                        break;
                    case 'switchingPeriod':
                        this.studentPeriod.switchingPeriod.message = data.switchingPeriod.message;
                        this.studentPeriod.switchingPeriod.loading = false;
                        break;
                    case 'refreshStudentPeriod':
                        this.studentPeriod.studentActivePeriods = data.studentPeriod;
                        this.studentPeriod.loading = false;
                        break;
                }


            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search_headTeacher', {'headTeacherName': query})
            },
            startReturnTips() {
                if (this.headTeacher_id != '' && this.parent_id != '') {
                    this.$confirm('确认是否开始回访?', '提示', {
                        StartReturn: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$wApi.send(this.path, 'start_return', {
                            'filter': this.filter,
                            'student_id': this.student_id
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                } else {
                    this.$alert('请先填写班主任和家长?', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                }
            },
            cancelReturnTips() {
                this.$confirm('是否取消回访，并删除本次回访记录。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'cancel_return', {'return_id': this.return_id})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            endReturnTips() {
                this.$confirm('请确认已完成全部回访操作，结束回访后将无法操作及修改。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'end_return', {
                        'form': this.form,
                        'return_id': this.return_id,
                        'student_id': this.student_id,
                        'problems':this.problems
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            }
        }
    };
</script>
